import { render, staticRenderFns } from "./Conventional.vue?vue&type=template&id=4bb43c78&"
import script from "./Conventional.vue?vue&type=script&lang=js&"
export * from "./Conventional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports